/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Payment_BillInputs */

const vi_grower_payment_bill = /** @type {(inputs: Grower_Payment_BillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ảnh bill`)
};

/**

* @param {Grower_Payment_BillInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_payment_bill = /** @type {((inputs?: Grower_Payment_BillInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Payment_BillInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_payment_bill(inputs)
});